import { useAppSelector } from 'store/hooks';
import { OrderSelectors } from 'store/Orders';
import { Order } from 'store/Orders/types';
import { useNavigationContext } from 'util/hooks/useNavigationContext';

export function useOrders() {
  const { activeRouteKey } = useNavigationContext();

  const filteredOrder: Order[] | undefined = useAppSelector((state) => {
    if (!activeRouteKey) return undefined;
    if (activeRouteKey === 'cooking') {
      return OrderSelectors.selectBeingPreparedItemsAsOrderFiltered(state);
    } else if (activeRouteKey === 'new') {
      return OrderSelectors.selectNotBeingPreparedItemsAsOrderFiltered(state);
    } else if (activeRouteKey === 'prepared') {
      return OrderSelectors.selectPreparedItemsAsOrderFiltered(state);
    } else if (activeRouteKey === 'scheduled') {
      return OrderSelectors.selectScheduledItemsAsOrderFiltered(state);
    } else if (activeRouteKey === 'newAndCooking') {
      return OrderSelectors.selectNewAndCookingItemsAsOrderFiltered(state);
    }
    return undefined;
  });

  return filteredOrder;
}
